module.exports = __webpack_public_path__ + "img/icon-music-black.91c693b7.png";